<template>
  <div
    class="rounded-md bg-surface-primary max-w-600 p-16 border-2 border-l-6 relative"
    :class="borderColor"
  >
    <nuxt-icon
      v-if="isCloseable"
      :filled="false"
      name="x"
      aria-label="Stäng meddelandet"
      class="text-[2rem] absolute top-18 right-18 text-text-primary cursor-pointer"
      @click="shouldShow = false"
    />
    <div class="flex flex-row gap-8"><slot name="header" /></div>

    <div class="pt-8">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  type?: 'success' | 'warning' | 'error' | 'info';
  isCloseable?: boolean;
  borderColor?: string;
}
withDefaults(defineProps<Props>(), {
  type: 'info',
  borderColor: 'border-border-information',
  isCloseable: false,
});

const shouldShow = defineModel<boolean>();
</script>

<style scoped></style>
